
import _ from 'lodash'
import { mapGetters } from 'vuex'
import { AEP, aepEffectiveDate, enrollmentDefaults } from '~/util/enrollment'

export default {
    props: {
        plan: {
            type: Object,
            default: null
        },
        date: {
            type: String,
            default: null
        },
    },
    data () {
        return {
            form: {
                effective_date: null,
                enrollment_period: null,
                payment_method: null,
                writing_agent_id: null,
            },
            writingAgents: [],
            e422: null,
            opportunity: null
        }
    },
    computed: {
        ...mapGetters([
            'client',
            'survey',
            'isAEP',
            'isSEPLEC',
            'isSEPMoving',
            'enrollmentPeriods',
            'paymentMethodsPerProduct',
            'nextYear',
            'summaryAep',
        ]),
        aep () {
            return this.form.enrollment_period === AEP
        },
    },
    watch: {
        // the agent's period select: AEP takes the opportunity's date, and
        // leaving AEP puts the survey's back
        'form.enrollment_period' (period, previous) {
            if (period === AEP) {
                this.form.effective_date = aepEffectiveDate(this.nextYear)
            } else if (previous === AEP) {
                this.form.effective_date = this.survey?.effective_date || null
            }
        },
    },
    async mounted () {
        const defaults = enrollmentDefaults({
            ep: this.$route.query.ep,
            periods: this.enrollmentPeriods.map(p => p.value),
            summaryAep: this.summaryAep,
            isAEP: this.isAEP,
            isSEPLEC: this.isSEPLEC,
            isSEPMoving: this.isSEPMoving,
            surveyEffectiveDate: this.survey?.effective_date,
            nextYear: this.nextYear,
        })
        this.$set(this.form, 'enrollment_period', defaults.enrollment_period)
        this.$set(this.form, 'effective_date', defaults.effective_date)

        this.$set(this.form, 'payment_method', 'MONTHLY_EFT')

        if (this.canAgent) {
            const { agents } = await this.$try('getAgentsForLocation', {
                // state: this.survey.state,
                // fips: this.survey.fips,
                active_ok: true
            })
            this.writingAgents = agents.map(agent => ({ text: this.toName(agent), value: agent.id }))
            if (_.find(this.writingAgents, option => option.value === this.survey.agent_id)) {
                this.$set(this.form, 'writing_agent_id', this.survey.agent_id)
            }
        }
    },
    methods: {
        async startEnrollment (options = {}) {
            if (!this.form.effective_date) {
                return this.$alert('Effective date is required!')
            }
            this.e422 = null
            this.opportunity = null
            const replace = options.replace === true
            if (this.canAgent) {
                const body = {
                    user: this.client?.id,
                    plan_id: this.plan?.id,
                    ...this.form,
                    replace
                }
                const { error, opportunity } = await this.$try('agentStartEnrollment', body, { alert: false })
                if (error?.response?.status === 422 && !replace) {
                    this.e422 = error
                    return
                }
                if (error) {
                    return this.$alert(error)
                }
                if (opportunity) {
                    this.opportunity = opportunity
                }
            } else {
                const { error } = await this.$try('startEnrollment', {
                    plan_id: this.plan?.id,
                    ...this.form,
                })
                if (error) {
                    return this.$alert(error)
                } else {
                    this.$router.push('/enroll-thank-you')
                    this.$emit('close')
                }
            }
        }
    },
}
